import React, { useImperativeHandle, forwardRef,useState, useRef, useEffect, useMemo } from "react"
import { CascadeSelect } from "primereact/cascadeselect";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import {
    Col,
    Container,
    Row
} from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import { FileUpload } from "primereact/fileupload";
import { Chips } from "primereact/chips";
import { InputText } from "primereact/inputtext";
import { Editor } from "primereact/editor";
import { ChevronDownIcon } from "primereact/icons/chevrondown"
import { ChevronRightIcon } from "primereact/icons/chevronright"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from "axios";
import { getBase64, triggerAlert } from "utils/CommonFunctions";
import { Toast } from "primereact/toast"

const SubmitCandidatetoJob = forwardRef(({ selectedCandidates }, ref) => {
    const toast = useRef(null)
    const [attachmentfile, setAttachmentfile] = useState([])
    const [skillsMap, setSkillsMap] = useState({});
    const fileListRef = useRef(null)
    const fileUploadRef = useRef(null)
    const [isSending, setIsSending] = useState(false);
    // submit candidate to job
    const [selectedSubmitOption, setSelectedSubmitOption] = useState(null)
    const [formErrors, setFormErrors] = useState({});
    const [frominputemail, setFrominputemail] = useState(null)
    const [isPrivate, setIsPrivate] = useState(true);
    const [defaultSignature, setDefaultSignature] = useState(null);
const [selectedSmsOption, setSelectedSmsOption] = useState(null);
const [signatureText, setSignatureText] = useState("");
const [templateBody, setTemplateBody] = useState("");
const [confirmNoSubject, setConfirmNoSubject] = useState(false);
const [pendingSendType, setPendingSendType] = useState(null);
// ...existing code...
const [jobDialogWarning, setJobDialogWarning] = useState(""); // Add this state
// ...existing code...

    

    const submitOptions = [
        {
            name: "Send Job to Candidate",
            code: "SUB-JOB",
            icon: "pi pi-briefcase",
        },
        {
            name: "Submit Candidate to Contact",
            code: "SUB-CONTACT",
            icon: "pi pi-user",
        },
    ]


    const fetchPrimaryFromEmail = async () => {
        try {
            const response = await axios.get(
                "/api/v1/smtp-accounts/by-primary/?is_primary=true"
            );
            if (
                Array.isArray(response.data) &&
                response.data.length > 0 &&
                response.data[0].is_primary &&
                response.data[0].from_email
            ) {
                setFrominputemail({
                    name: response.data[0].from_email,
                    code: response.data[0].from_email,
                });
                setFromemailjobs(response.data[0].from_email);
                console.log("Primary from email set:", response.data[0].from_email);
            }
            // If not primary or no email, do not overwrite previous value
        } catch (error) {
            // If API fails, do not overwrite previous value
            console.error("Error fetching primary from email:", error);
        }
    };


    useImperativeHandle(ref, () => ({
        openSubmitJob: () => handleOpenDialogs(true),
        openSubmitContact: () => handleSubmitContact(true),
      }));
      const fetchSkills = async () => {
    try {
        const response = await axios.get("/api/v1/get-all-skills/");
        const skills = response.data.results.reduce((map, skill) => {
            map[skill.skill_id] = skill.skill_name;
            return map;
        }, {});
        setSkillsMap(skills);
    } catch (error) {
        triggerAlert("error", "Error fetching skills", "Unable to fetch skills. Please try again later.");
        console.error("Error fetching skills:", error);
    }
};
      


    const handleSubmitCandidate = e => {
        setSelectedSubmitOption(e.value)
        if (e.value?.code === "SUB-JOB") {
            if (selectedCandidates.length > 0) {
                handleOpenDialogs(true)
            } else {
                toast.current.show({ severity: "info", summary: "Info", detail: "Please select candidate", life: 3000 });
            }

        } else if (e.value?.code === "SUB-CONTACT") {
            if (selectedCandidates.length > 0) {
                handleSubmitContact(true);
            } else {
                toast.current.show({ severity: "info", summary: "Info", detail: "Please select candidate", life: 3000 });
            }
        }
    }

    const handleSubmitContact = () => {
        fetchPrimaryFromEmail();
        SetSubmitcantocon(true)
        setFormErrors({})

        setTimeout(() => {
            setccDetailsVisible(true)
        }, 3000)
    }
    // const [submitcantocon, SetSubmitcantocon] = useState(false)
    const userInfo = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const userEmail = userInfo?.user_details?.email;
    // console.log("userEmail", userEmail,userInfo);
     const [fromemailjobs, setFromemailjobs] = useState(userEmail || '');
    const Fromemailcontjobs = item => {
        return (
            <div>
                <span>{item}</span>
            </div>
        )
    }

    // jobs all chip ends

  const footerContent = (
    <div>
        <div className="d-flex align-items-center">
            <Checkbox
                inputId="checkbox"
                checked={isPrivate}
                onChange={(e) => setIsPrivate(e.checked)}
            />
            <label htmlFor="checkbox" className="ms-2 mt-1">
                Private
            </label>
        </div>
    </div>
);
    const [selectedEmailOption1, setSelectedEmailOption1] = useState(null)
    const [emailOptions1, setemailOptions1] = useState([])

const fetchDefaultSignature = async () => {
  try {
    const response = await axios.get(`/api/v1/email-signatures/default/`);
    if (response.data && Array.isArray(response.data) && response.data.length > 0 && response.data[0].signature_text) {
      setDefaultSignature(response.data[0]);
    }
  } catch (error) {
    console.error("Error fetching default signature:", error);
  }
};

//sais code
const gettemplateitems = async () => {
  try {
    const response = await axios.get(`/api/v1/email-templates/`);
    const transformedData = response.data.map((city) => ({
      label: city.name,
      id: city.template_id,
      body: city.body,
      is_default: city.is_default || false,
    }));
    setemailOptions1(transformedData);

    // Only set default if is_default is true
    const defaultTemplate = transformedData.find(t => t.is_default);
    if (defaultTemplate) {
      setSelectedEmailOption1(defaultTemplate);
      setTemplateBody(defaultTemplate.body || "");
    } else {
      setSelectedEmailOption1(null);
      setTemplateBody("");
    }
  } catch (error) {
    triggerAlert("error", "Error", "Unable to fetch email templates. Please try again later.");
  }
};

//sais code
function extractCandidateRows(emailBody) {
  if (!emailBody) return { candidateRows: "" };
  // Find the last </table> (end of candidate rows)
  const lastTableIndex = emailBody.lastIndexOf("</table>");
  if (lastTableIndex === -1) return { candidateRows: "" };
  // Extract everything from the first <table> to the last </table>
  const firstTableIndex = emailBody.indexOf("<table");
  const candidateRows = emailBody.substring(firstTableIndex, lastTableIndex + 8).trim();
  return { candidateRows };
}

//sais code
const handleTemplateChange = async (e) => {
  try {
    const templateId = e.value.id;
    setSelectedEmailOption1(e.value);

    if (!templateId) {
      setTemplateBody("");
      // Remove template and signature, keep only candidate rows
      setEmailtextEditor((prev) => {
        const { candidateRows } = extractCandidateRows(prev);
        return candidateRows;
      });
      return;
    }

    const response = await axios.get(`/api/v1/email-templates/${templateId}/`);
    if (response?.data) {
      const { body } = response.data;
      setTemplateBody(body || "");

      // Remove old template and signature, keep only candidate rows
      setEmailtextEditor((prev) => {
        const { candidateRows } = extractCandidateRows(prev);
        const signature = selectedSmsOption?.signature_text || "";
        return `
          <p>Dear {{contact_name}},</p>
  <br />
  ${body ? `<div>${body}</div><br />` : ""}
  <br />
  <div>
    ${candidateRows}
  </div>
  <br />
  ${signature ? `<br /><br />${signature}` : ""}
        `;
      });
    }
  } catch (error) {
    console.error("Error fetching template:", error);
    setTemplateBody("");
    setEmailtextEditor((prev) => {
      const { candidateRows } = extractCandidateRows(prev);
      return candidateRows;
    });
  }
};

    const selectedEmailTemplate1 = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <i className={`${option.icon} mr-2`}></i>
                    <div>{option.label}</div>
                </div>
            )
        }
        return (
            <div className="flex align-items-center">
                <i className="pi pi-envelope mr-2"></i>
                <span>{props.placeholder}</span>
            </div>
        )
    }
    const emailOptionTemplate1 = option => {
        return (
            <div className="flex align-items-center">
                <i className={`${option.icon} mr-2`}></i>
                <div>{option.label}</div>
            </div>
        )
    }
    const [smsOptions1, setsmsOptions1] = useState([])

    //sais code
// const getsignatureitems = async () => {
//   try {
//     const response = await axios.get(`/api/v1/email-signatures/`);
//     const transformedData = response.data.map((city) => ({
//       label: city.name,
//       id: city.signature_id,
//       is_default: city.is_default || false,
//       signature_text: city.signature_text,
//     }));
//     setsmsOptions1(transformedData);

//     // Only set default if is_default is true
//     const defaultSig = transformedData.find(sig => sig.is_default);
//     if (defaultSig) {
//       setDefaultSignature(defaultSig);
//       setSelectedSmsOption(defaultSig);
//       setSignatureText(defaultSig.signature_text);
//     } else {
//       setDefaultSignature(null);
//       setSelectedSmsOption(null);
//       setSignatureText("");
//     }
//   } catch (error) {
//     triggerAlert("error", "Error", "Unable to fetch email signatures. Please try again later.");
//   }
// };
const getsignatureitems = async () => {
  try {
    const response = await axios.get(`/api/v1/email-signatures/`);
    const transformedData = response.data.map((city) => ({
      label: city.name,
      id: city.signature_id,
      is_default: city.is_default || false,
      signature_text: city.signature_text,
    }));
    setsmsOptions1(transformedData);

    // Set default signature if present
    const defaultSig = transformedData.find(sig => sig.is_default);
    if (defaultSig) {
      setDefaultSignature(defaultSig);
      setSelectedSmsOption(defaultSig);
      setSignatureText(defaultSig.signature_text);
    } else {
      setDefaultSignature(null);
      setSelectedSmsOption(null);
      setSignatureText("");
    }
  } catch (error) {
    triggerAlert("error", "Error", "Unable to fetch email signatures. Please try again later.");
  }
};

const getDefaultTemplate = () => {
    if (emailOptions1 && emailOptions1.length > 0) {
        // You may need to adjust this if your API marks default differently
        return emailOptions1[0]; // Assuming first is default
    }
    return null;
};
const getDefaultSignature = () => {
    if (smsOptions1 && smsOptions1.length > 0) {
        return smsOptions1.find(sig => sig.is_default) || smsOptions1[0];
    }
    return null;
};

const handleSignatureChange = async (e) => {
  try {
    const signatureId = e.value?.id;
    setSelectedSmsOption(e.value);

    if (!signatureId) {
      setSignatureText("");
      const { candidatePart } = stripTemplate(emailtextEditor);
      setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}`);
      return;
    }

    const response = await axios.get(`/api/v1/email-signatures/${signatureId}/`);
    if (response?.data) {
      const { signature_text } = response.data;
      setSignatureText(signature_text || "");
      const { candidatePart } = stripTemplate(emailtextEditor);
      setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}${signature_text ? `<br>${signature_text}` : ''}`);
    }
  } catch (error) {
    console.error("Error fetching signature:", error);
    setSignatureText("");
    const { candidatePart } = stripTemplate(emailtextEditor);
    setEmailtextEditor(`${candidatePart}${templateBody ? `<br>${templateBody}` : ''}`);
  }
};


    const [uploadedFiles, setUploadedFiles] = useState([]);


    const onUploadHandler1 = async (e) => {
        const newError = {};

        const maxSize = 10 * 1024 * 1024; // 10MB

        const programmingFileExtensions = [
            ".js", ".ts", ".tsx", ".jsx",
            ".java", ".py", ".cpp", ".c", ".cs",
            ".rb", ".php", ".go", ".rs", ".swift",
            ".kt", ".sh", ".pl", ".html", ".xml"
        ];

        const newFiles = e.files || [];

        const validFiles = await Promise.all(
            newFiles.map(async (file) => {
                const fileName = file.name.toLowerCase();

                // ❌ Block programming files by extension
                if (programmingFileExtensions.some(ext => fileName.endsWith(ext))) {
                    newError.attachment = `Programming files are not allowed: ${file.name}`
                    setFormErrors(...prev, newError);
                    return null;
                }

                // ❌ Block large files
                if (file.size > maxSize) {
                    newError.attachment = `File "${file.name}" exceeds 10MB size limit.`
                    setFormErrors(...prev, newError);
                    return null;
                }

                const base64 = await getBase64(file);
                return {
                    file_name: file.name,
                    file_data: base64,
                };
            })
        );

        const filteredFiles = validFiles.filter(Boolean);

        if (filteredFiles.length === 0) return;

        setAttachmentfile((prevFiles) => [...prevFiles, ...filteredFiles]);
        setFormErrors(""); // ✅ Clear any error

        // ✅ Clear upload component if needed
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

    const [emailtextEditor, setEmailtextEditor] = useState("")

    const selectedSmsTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <i className={`${option.icon} mr-2`}></i>
                    <div>{option.label}</div>
                </div>
            )
        }
        return (
            <div className="flex align-items-center">
                <i className="pi pi-comment mr-2"></i>
                <span>{props.placeholder}</span>
            </div>
        )
    }

    const smsOptionTemplate = option => {
        return (
            <div className="flex align-items-center">
                <i className={`${option.icon} mr-2`}></i>
                <div>{option.label}</div>
            </div>
        )
    }

    const [selectedOption, setSelectedOption] = useState(null)

    const selectedOptionTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <i className={`${option.icon} mr-2`}></i>
                    <div>{option.label}</div>
                </div>
            )
        }
        return (
            <div className="flex align-items-center">
                <i className="pi pi-cog mr-2"></i>
                <span>{props.placeholder}</span>
            </div>
        )
    }

    const optionTemplate = option => {
        return (
            <div className="flex align-items-center">
                <i className={`${option.icon} mr-2`}></i>
                <div>{option.label}</div>
            </div>
        )
    }
    const [fromEmail, setfromEmail] = useState([])

    const fetchFromMails = async () => {
    try {
        const response = await axios.get(`/api/v1/smtp-accounts/`, {});
        const transformedData = response.data?.results?.map((item) => ({
            name: item.from_email,
            code: item.from_email,
        }));
        console.log("fetchFromMails transformedData:", transformedData);
        setfromEmail(transformedData);
    } catch (error) {
        triggerAlert("error", "Error", "Unable to fetch from emails. Please try again later.");
        console.error('Error fetching states:', error);
    }
};
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [lazyParamsContacts, setLazyParamsContacts] = useState({ page: 0, rows: 10 });
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false)
    const [selectedJobTitles, setSelectedJobTitles] = useState([]);
    const [searchText, setSearchText] = useState("")
    const [selectedJobs, setSelectedJobs] = useState([])
    const [jobDescriptions, setJobDescriptions] = useState([])

    const [jobs, setJobs] = useState([]);




    const filteredJobs = jobs.filter(
        (job) =>
            job.title.toLowerCase().includes(searchText.toLowerCase()) ||
            job.manager.toLowerCase().includes(searchText.toLowerCase()) ||
            job.job_number.toString().includes(searchText)
    );

    const handleSave = () => {
const contactDetails = selectedJobs.map(job => ({
            name: job.contact,
            email: job.contactemail,
            id: job.id,
        }));
        setSelectedJobTitles((prev) => [...prev, ...contactDetails]);

        // Close the Job Details dialog
        setJobDetailsVisible(false);
    }

    const handleRefresh = () => {
        setSelectedJobs([])
        setSearchText("")
    }

    // popup
    const [jobsallpopup, SetJobsallPopup] = useState(false)
    const [jobssearchedpopup, SetJobssearchedPopup] = useState(false)
    const [jobsselectedpopup, SetJobsselectedPopup] = useState(false)


    const handleOpenDialogs = () => {
        fetchPrimaryFromEmail();
        // Open the first dialog
        SetJobsallPopup(true)
        setFormErrors({})

        // Automatically open the second dialog after a short delay
        setTimeout(() => {
            setJobDetailsVisible(true)
        }, 3000)
    }

    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };
    const onPageContactsChange = (event) => {
        setLazyParamsContacts({ page: event.page, rows: event.rows });
    };
    const getallactivejobs = async () => {

        try {
            const page = lazyParams?.page ?? 0;
            const rows = lazyParams?.rows ?? 10;
            const response = await axios.get(`/api/v1/jobs/?page=${page + 1}&size=${rows}&status=Approved / Open`, {

            });
            if (response.status === 200) {
                const transformedData = response.data.results.map((cond) => ({
                    title: cond.job_title,
                    id: cond.job_id,
                    manager: cond.hiring_manager_name,
                    manager: cond.hiring_manager_name,
                    job_number: cond.job_number
                }));
                setJobs(transformedData);
                setTotalRecords(response.data.count || 0)

            } else {
                setJobs([]);
                setTotalRecords(0);
            }


        } catch (error) {
            triggerAlert("error", "Error fetching jobs", "Unable to fetch jobs. Please try again later.");
            console.error('Error fetching states:', error);
        }
    };
    useEffect(() => {

        getallactivejobs();
    }, [lazyParams.page, lazyParams.rows]);
    useEffect(() => {

        fetchContacts();
        console.log('selectedContacts1',selectedContacts1)
        console.log('selectedContacts',selectedContacts)
    }, [lazyParamsContacts.page, lazyParamsContacts.rows, searchText]);
    useEffect(() => {
        // console.log("lazyParams", lazyParams)
        gettemplateitems();
        getsignatureitems();
        fetchFromMails();
        fetchSkills();
        fetchDefaultSignature();
    }, []);

    // sai's code changed
const submitCandidateToJob = async () => {
    const newErrors = {};

    // Validate fromemailjobs (should be a non-empty string)
    if (!fromemailjobs || typeof fromemailjobs !== "string" || fromemailjobs.trim() === "") {
        newErrors.from = "From email is required";
    }

    // Validate jobDescriptions
    if (!Array.isArray(jobDescriptions) || jobDescriptions.length === 0) {
        newErrors.to = "To address is required";
    }

    // Validate subject
    // if (typeof subject !== "string" || subject.trim() === "") {
    //     newErrors.subject = "Subject is required";
    // }

    // Validate emailtextEditor
    if (typeof emailtextEditor !== "string" || emailtextEditor.trim() === "") {
        newErrors.body = "Email body is required";
    }

    // Check for errors or if already sending
    if (Object.keys(newErrors).length > 0 || isSending) {
        setFormErrors(newErrors);
        return;
    }

    try {
        setIsSending(true);
        setFormErrors({});

        const payload = {
            job_id: selectedJobTitles?.map(job => job.id).join(', '),
            candidate: selectedCandidates?.map(candidate => ({
                candidate: candidate.candidate_id,
                first_name: candidate.first_name,
                middle_name: candidate.middle_name,
                last_name: candidate.last_name,
                designation: candidate.designation,
                current_company: candidate.current_company,
                candidate_email: candidate.email,
            })),
            from_address: fromemailjobs,
            to_addresses: jobDescriptions,
            cc_addresses: contactDescriptions,
            subject: subject,
            body: emailtextEditor,
            attachments: attachmentfile || [],
            is_private: isPrivate
        };

        const response = await axios.post('/api/v1/submit-candidate-job/', payload);

        if (response.status === 201) {
            SetJobsallPopup(false);
            toast.current.show({ severity: 'success', summary: 'Success', detail: response.data.message });
                // Show grouped warning toast for skipped candidates
                if (response.data.skipped && Array.isArray(response.data.skipped) && response.data.skipped.length > 0 && toast && toast.current) {
                    // Get unique candidate names from skipped array
                    const skippedNames = [...new Set(response.data.skipped.map(c => c.candidate_name))].join(", ");
                    toast.current.show({ severity: 'warn', summary: 'Skipped Candidates', detail: `${skippedNames} skipped`, life: 6000 });
                }
            resetForm();
        } else {
            SetJobsallPopup(false);
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: response.data.message });
            resetForm();
                setIsSending(false); // Stop the request (set loading to false)
    return;
        }
    } catch (error) {
        if (error.response) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: `Error ${error.response.status}: Submission failed - ${error.response.data.error}`,
            });
        } else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Submission failed - Network Error or No Response",
            });
        }
    } finally {
        setIsSending(false);
    }
};

    // jobs all ends


    // select contacts starts

    const [linkContactsVisible, setLinkContactsVisible] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [totalContacts, setTotalContacts] = useState(0);
const fetchContacts = async () => {

        try {
            const page = lazyParamsContacts?.page ?? 0;
            const rows = lazyParamsContacts?.rows ?? 10;
            const response = await axios.get(`/api/v1/contacts/?page=${page + 1}&size=${rows}&status=Active&company_id=${companyId}`);
            if (response.data) {
                let results = response.data.results;
                const filteredContacts = results.filter(
                    (contact) =>
                        contact?.role_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
                        contact?.contact_name?.toLowerCase().includes(searchText?.toLowerCase()) ||
                        contact?.email?.toLowerCase().includes(searchText?.toLowerCase()) ||
                        contact?.id?.toString().includes(searchText)
                );
                setContacts(filteredContacts);
                setTotalContacts(response.data.count || 0)
            }
        } catch (error) {
            triggerAlert("error", "Error fetching contacts", "Unable to fetch contacts. Please try again later.");
            console.log('error fetch contacts', error);
        }
    };



    const handleSaveContact = () => {
        const contactDetails = selectedContacts.map((contact) => ({
            name: contact.contact_name,
            email: contact.email,
        }));
        const formattedContacts = contactDetails.map(
            (contact) => contact.email
        );
        setJobDescriptions((prev) => [...prev, ...formattedContacts]);
        setLinkContactsVisible(false);
    };

    const handleRefresh1 = () => {
        setSelectedContacts([]); // Reset selected contacts
        setSearchText(""); // Reset search text
    };


    // select contact ends

    // select cc contacts starts
    const [subject, setSubject] = useState("");
    const [contactDescriptions, setContactDescriptions] = useState([]);
    const [linkContactsVisible1, setLinkContactsVisible1] = useState(false);
    const [selectedContacts1, setSelectedContacts1] = useState([]);

     const resetForm = () => {
        setFrominputemail(null);
        setFromemailjobs(userEmail ? userEmail : '');
        setJobDescriptions([]);
        setContactDescriptions([]);
        setSubject("");
        setEmailtextEditor("");
        setIsPrivate(true);
        setAttachmentfile([]);
        setSelectedEmailOption1(null);
        setSelectedSmsOption(null);
        setSelectedJobs([]);
        setSelectedJobTitles([]);
        setSearchText("");
        setFormErrors({});
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };

      const resetFormContact = () => {
        setFrominputemail(null);
        setFromemailjobs(userEmail ? userEmail : []);
        setJobDescriptions([]);
        setContactDescriptions([]);
        setContactDescriptionscc([]); // Reset CC for Submit Candidate to Contact
        setAutoToemail([]); // Reset To for Submit Candidate to Contact
        setSubject("");
        setEmailtextEditor("");
        setAttachmentfile([]);
        setSelectedEmailOption1(null);
        setSelectedSmsOption(null);
        setSelectedJobs([]);
        setSelectedJobTitles([]); // Already an array from previous fix
        setSelectedContacts([]);
        setSelectedContacts1([]);
        setSelectedContactsto([]);
        setSelectedContactscc([]);
        setSelectedAutocc([]);
        setSearchText("");
        setFormErrors({});
        if (fileUploadRef.current) {
            fileUploadRef.current.clear();
        }
    };
    


    const handleSaveContact1 = () => {
        const contactDetails = selectedContacts1.map((contact) => ({
            name: contact.contact_name,
            email: contact.email,
        }));
        const formattedContacts = contactDetails.map(
            (contact) => `${contact.email}`
        );
        setContactDescriptions((prev) => [...prev, ...formattedContacts]);
        setLinkContactsVisible1(false);
    };

    const handleRefresh2 = () => {
        setSelectedContacts1([]); // Reset selected contacts
        setSearchText(""); // Reset search text
    };

    // select cc contact ends


    // submit candidate to contact starts

    const [submitcantocon, SetSubmitcantocon] = useState(false)

    // auto popup
    const [ccDetailsVisible, setccDetailsVisible] = useState(false)
    const [selectedAutocc, setSelectedAutocc] = useState([])
    const [autoToemail, setAutoToemail] = useState([])


    const handleSaveautocc = () => {
        // Extract cc details from selected jobs
        const contactDetails = selectedAutocc.map(cc => ({
            id: cc.id,
            name: cc.contact_name,
            email: cc.email,
        }));
const formattedContacts = contactDetails.map((contact) => ({
    id: contact.id,
              label: contact.email?.trim() ? contact.email : "N/A",
     email: contact.email,
  }));

  setAutoToemail((prev) => {
    const existingIds = new Set(prev.map(item => item.id));
    const uniqueContacts = formattedContacts.filter(c => !existingIds.has(c.id));
    return [...prev, ...uniqueContacts];
  });

        // Close the Job Details dialog
        setccDetailsVisible(false);
    }

    const handleRefreshautocc = () => {
        setSelectedAutocc([])
        setSearchText("")
    }

    // select contacts to starts

    const [linkContactstoVisible, setLinkContactstoVisible] = useState(false);
    const [selectedContactsto, setSelectedContactsto] = useState([]);


    const handleSaveContactto = () => {
        const contactDetails = selectedContactsto.map((contact) => ({
            id: contact.id,
             name: contact.contact_name,
            email: contact.email,
        }));
const formattedContacts = contactDetails.map((contact) => ({
    id: contact.id,
              label: contact.email?.trim() ? contact.email : "N/A",
     email: contact.email,
  }));

  setAutoToemail((prev) => {
    const existingIds = new Set(prev.map(item => item.id));
    const uniqueContacts = formattedContacts.filter(c => !existingIds.has(c.id));
    return [...prev, ...uniqueContacts];
  });

        setLinkContactstoVisible(false);
    };

    const handleRefreshto = () => {
        setSelectedContactsto([]); // Reset selected contacts
        setSearchText(""); // Reset search text
    };


    // select contact to ends

    // select cc contacts starts
    const [contactDescriptionscc, setContactDescriptionscc] = useState([]);
    const [linkContactsVisiblecc, setLinkContactsVisiblecc] = useState(false);
    const [selectedContactscc, setSelectedContactscc] = useState([]);


    const handleSaveContactcc = () => {
        const contactDetails = selectedContactscc.map((contact) => ({
            name: contact.contact_name,
            email: contact.email,
        }));
        const formattedContacts = contactDetails.map(
            (contact) => contact.email ? contact.email : "N/A"
        );
        // setContactDescriptionscc((prev) => [...prev, ...formattedContacts]);
          setContactDescriptionscc((prev) => {
    const uniqueSet = new Set([...prev, ...formattedContacts]);
    return Array.from(uniqueSet);
  })
        setLinkContactsVisiblecc(false);
    };

    const handleRefreshcc = () => {
        setSelectedContactscc([]); // Reset selected contacts
        setSearchText(""); // Reset search text
    };

useEffect(() => {
  if (smsOptions1.length > 0 && defaultSignature) {
    const defaultSig = smsOptions1.find(signature => signature.id === defaultSignature.id);
    if (defaultSig) {
      setSelectedSmsOption(defaultSig);
    }
  }
}, [smsOptions1, defaultSignature]);


const stripTemplate = (emailBody) => {
  if (!emailBody) return { candidatePart: '', signaturePart: '' };
  const lastTableIndex = emailBody.lastIndexOf("</table>");
  if (lastTableIndex === -1) return { candidatePart: '', signaturePart: '' };
  const candidatePart = emailBody.substring(0, lastTableIndex + 8).trim();
  const afterTable = emailBody.substring(lastTableIndex + 8);
  const signatureMarkers = [/<br\s*\/?>\s*Best Regards,/i, /<br\s*\/?>\s*$/i];
  let signatureStartIndex = -1;
  for (const marker of signatureMarkers) {
    signatureStartIndex = afterTable.search(marker);
    if (signatureStartIndex !== -1) break;
  }
  const signaturePart = signatureStartIndex !== -1 ? afterTable.substring(signatureStartIndex).trim() : '';
  return { candidatePart, signaturePart };
};




useEffect(() => {
    const newErrors = { ...formErrors };

    // Debug: Log fromemailjobs to verify its value
    console.log("Validation - fromemailjobs:", fromemailjobs, "type:", typeof fromemailjobs);

    // Validate fromemailjobs
    if (typeof fromemailjobs === "string" && fromemailjobs.trim() !== "") {
        delete newErrors.from;
    } else {
        newErrors.from = "From email is required";
    }

    // Validate To field based on dialog context
    if (jobsallpopup) {
        // For Submit Candidate to Job
        if (Array.isArray(jobDescriptions) && jobDescriptions.length > 0) {
            delete newErrors.to;
        } else {
            newErrors.to = "To address is required";
        }
    } else if (submitcantocon) {
        // For Submit Candidate to Contact
        if (Array.isArray(autoToemail) && autoToemail.length > 0) {
            delete newErrors.to;
        } else {
            newErrors.to = "To address is required";
        }
    }

    // Validate subject
    // if (typeof subject === "string" && subject.trim() !== "") {
    //     delete newErrors.subject;
    // } else {
    //     newErrors.subject = "Subject is required";
    // }

    // Validate emailtextEditor
    if (typeof emailtextEditor === "string" && emailtextEditor.trim() !== "") {
        delete newErrors.body;
    } else {
        newErrors.body = "Email body is required";
    }

    setFormErrors(newErrors);
}, [fromemailjobs, jobDescriptions, autoToemail, subject, emailtextEditor, jobsallpopup, submitcantocon]);
    // select cc contact ends

    //  const submitCandidateToContact = async () => {
    //     const newErrors = {};
    //     console.log("fromemailjobs", fromemailjobs)
    //     if (
    //         !Array.isArray(fromemailjobs) ||
    //         fromemailjobs.length === 0 ||
    //         fromemailjobs.some(email => typeof email !== "string" || email.trim() === "")
    //     ) {
    //         newErrors.from = "From email is required";
    //     }

    //     if (!Array.isArray(autoToemail) || autoToemail.length === 0) {
    //         newErrors.to = "To address is required";
    //     }

    //     if (typeof subject !== "string" || subject.trim() === "") {
    //         newErrors.subject = "Subject is required";
    //     }

    //     if (typeof emailtextEditor !== "string" || emailtextEditor.trim() === "") {
    //         newErrors.body = "Email body is required";
    //     }

    //     if (Object.keys(newErrors).length > 0) {
    //         setFormErrors(newErrors);
    //         return;
    //     }


    //     try {
    //         // ✅ Clear errors
    //         setFormErrors({});
    //         const payload = {
    //             contact_id: autoToemail?.map(contact => contact.id).join(', '),
    //             candidate: selectedCandidates?.map(candidate => {
    //                 return {
    //                     candidate: candidate.candidate_id,
    //                     first_name: candidate.first_name,
    //                     middle_name: candidate.middle_name,
    //                     last_name: candidate.last_name,
    //                     designation: candidate.designation,
    //                     current_company: candidate.current_company,
    //                     candidate_email: candidate.email
    //                 }

    //             }),
    //             from_address: fromemailjobs,
    //             to_addresses: autoToemail?.map(contact => contact.email),
    //             cc_addresses: contactDescriptionscc,
    //             subject: subject,
    //             body: emailtextEditor,
    //             attachments: attachmentfile ? attachmentfile : [],

    //         }
    //         console.log("first payload", payload)
    //         // return
    //         const response = await axios.post('/api/v1/submit-candidate-contact/', payload);

            
    //         console.log(response.data);
    //         if (response.status === 201) {
    //             SetSubmitcantocon(false)
    //             toast.current.show({ severity: 'success', summary: 'Success', detail: response.data.message });
    //             resetFormContact()
    //             // triggerAlert('success', "", response.data.message);
    //         } else {
    //             toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
    //             // triggerAlert('error', "", response.data.message);
    //         }

    //     } catch (err) {
    //         console.log(err);
    //     }
    // }

    // sai's changed code
const submitCandidateToContact = async () => {
    const newErrors = {};

    // Validate fromemailjobs (should be a non-empty string)
    if (!fromemailjobs || typeof fromemailjobs !== "string" || fromemailjobs.trim() === "") {
        newErrors.from = "From email is required";
    }

    // Validate autoToemail
    if (!Array.isArray(autoToemail) || autoToemail.length === 0) {
        newErrors.to = "To address is required";
    }

    // Validate subject
    // if (typeof subject !== "string" || subject.trim() === "") {
    //     newErrors.subject = "Subject is required";
    // }

    // Validate emailtextEditor
    if (typeof emailtextEditor !== "string" || emailtextEditor.trim() === "") {
        newErrors.body = "Email body is required";
    }

    // Check for errors or if already sending
    if (Object.keys(newErrors).length > 0 || isSending) {
        setFormErrors(newErrors);
        return;
    }

    try {
        setIsSending(true);
        setFormErrors({});

        const payload = {
            contact_id: autoToemail?.map(contact => contact.id).join(', '),
            candidate: selectedCandidates?.map(candidate => ({
                candidate: candidate.candidate_id,
                first_name: candidate.first_name,
                middle_name: candidate.middle_name,
                last_name: candidate.last_name,
                designation: candidate.designation,
                current_company: candidate.current_company,
                candidate_email: candidate.email
            })),
            from_address: fromemailjobs,
            to_addresses: autoToemail?.map(contact => contact.email),
            cc_addresses: contactDescriptionscc,
            subject: subject,
            body: emailtextEditor,
            attachments: attachmentfile || [],
            is_private: isPrivate
        };

        const response = await axios.post('/api/v1/submit-candidate-contact/', payload);

        if (response.status === 201) {
            SetSubmitcantocon(false);
            toast.current.show({ severity: 'success', summary: 'Success', detail: response.data.message });
                // Show grouped warning toast for skipped candidates
                if (response.data.skipped && Array.isArray(response.data.skipped) && response.data.skipped.length > 0 && toast && toast.current) {
                    const skippedNames = [...new Set(response.data.skipped.map(c => c.candidate_name))].join(", ");
                    toast.current.show({ severity: 'warn', summary: 'Skipped Candidates', detail: `${skippedNames} skipped`, life: 6000 });
                }
            resetFormContact();
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message });
        }
    } catch (error) {
        if (error.response) {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: `${error.response.data.error}`,
            });
        } else {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Submission failed - Network Error or No Response",
            });
        }
    } finally {
        setIsSending(false);
    }
};
    
useEffect(() => {
  if ((jobsallpopup || submitcantocon) && smsOptions1.length > 0) {
    // If no signature is selected, set the default
    if (!selectedSmsOption) {
      const defaultSig = smsOptions1.find(sig => sig.is_default);
      if (defaultSig) {
        setSelectedSmsOption(defaultSig);
        setSignatureText(defaultSig.signature_text);
      }
    }
  }
  // eslint-disable-next-line
}, [jobsallpopup, submitcantocon, smsOptions1]);

// sais code
useEffect(() => {
  if (jobsallpopup || submitcantocon) {
    // Get selected template and signature (only if selected, not just present in the list)
    const templateBody = selectedEmailOption1?.body || "";
     const signature = selectedSmsOption?.signature_text
      || defaultSignature?.signature_text
      || "";

        const tableStyle = "width:100%;border-collapse:collapse;border:1px solid #333;font-family:Arial,sans-serif;font-size:14px;";
    const thStyle = "background:#f5f5f5;border:1px solid #333;padding:8px;text-align:left;";
    const tdStyle = "border:1px solid #333;padding:8px;";
    // Build candidate rows
    let candidateRows = "";
    if (selectedCandidates && selectedCandidates.length > 0) {
      candidateRows = selectedCandidates.map((candidate) => {
        let primarySkills = "-";
        if (Array.isArray(candidate.primary_skills)) {
          primarySkills = candidate.primary_skills
            .map((id) => skillsMap[id] || id)
            .join(", ");
        } else if (typeof candidate.primary_skills === "string" && candidate.primary_skills) {
          primarySkills = candidate.primary_skills
            .split(",")
            .map((id) => skillsMap[id.trim()] || id)
            .join(", ");
        }
        return `
          <table style="${tableStyle}">
            <tr>
              <td style="${tdStyle} width:25%;"><b>Candidate Name:</b></td>
              <td style="${tdStyle} width:75%;">${candidate.first_name} ${candidate.last_name ?? ''}</td>
            </tr>
            <tr>
              <td style="${thStyle} width:25%;"><b>Primary Skills:</b></td>
              <td style="${tdStyle} width:75%;">${primarySkills}</td>
            </tr>
            <tr>
              <td style="${thStyle} width:25%;"><b>Contact Details</b></td>
              <td style="${tdStyle} width:75%;"><strong>Phone:</strong> ${candidate.mobile_phone || 'N/A'}; <strong>Email:</strong> ${candidate.email || 'N/A'}</td>
            </tr>
            <tr>
              <td style="${tdStyle} width:25%;"><b>Work Experience</b></td>
              <td style="${tdStyle} width:75%;">${candidate.total_experience || '-'} Yrs</td>
            </tr>
            <tr>
              <td style="${tdStyle} width:25%;"><b>Details</b></td>
              <td style="${tdStyle} width:75%;">
                <b>Salary Expectation:</b> \₹ ${candidate.expected_salary || 'N/A'},
                <b>Availability:</b> ${candidate.availability_date || 'N/A'},
                <b>Employment Type:</b> ${candidate.employee_type || 'N/A'}
              </td>
            </tr>
          </table>
        `;
      }).join('<br>');
    }

    // Compose the email content
    const emailContent = `
<p>Dear {{contact_name}},</p>
  <br />
  ${templateBody ? `<div>${templateBody}</div><br />` : ""}
  <br />
  <div>
    ${candidateRows}
  </div>
  <br />
  ${signature ? `<br /><br />${signature}` : ""}
    `;
    setEmailtextEditor(emailContent);
  }
}, [
  jobsallpopup,
  submitcantocon,
  selectedEmailOption1,
  selectedSmsOption,
  selectedCandidates,
  skillsMap,
  defaultSignature
]);

useEffect(() => {
  if ((jobsallpopup || submitcantocon) && selectedCandidates && selectedCandidates.length > 0) {
    const validResumes = selectedCandidates
      .filter(candidate => candidate.resume)
      .map(candidate => ({ file_name: `${candidate.first_name}_${candidate.last_name}_resume.pdf`, file_data: candidate.resume }));
    setAttachmentfile(validResumes);
  }
}, [jobsallpopup, submitcantocon, selectedCandidates]);

  const handleSendJob = () => {
    if (!subject || subject.trim() === "") {
        setPendingSendType("job");
        setConfirmNoSubject(true);
        return;
    }
    submitCandidateToJob();
};
const handleSendContact = () => {
    if (!subject || subject.trim() === "") {
        setPendingSendType("contact");
        setConfirmNoSubject(true);
        return;
    }
    submitCandidateToContact();
};

const handleConfirmSend = () => {
    setConfirmNoSubject(false);
    if (pendingSendType === "job") {
        submitCandidateToJob();
    } else if (pendingSendType === "contact") {
        submitCandidateToContact();
    }
    setPendingSendType(null);
};

const handleCancelSend = () => {
    setConfirmNoSubject(false);
    setPendingSendType(null);
};



    // submit candidate to contact ends
    return (
        <React.Fragment>
            <Toast ref={toast} />
            <CascadeSelect
                // value={selectedSubmitOption}
                onChange={handleSubmitCandidate}
                options={submitOptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={["subItems", "subItems"]}
                className="md:w-10rem me-1"
                breakpoint="767px"
                placeholder="Submit"
            />


            {/* submit candidate to job */}
            <Dialog
                header="Submit Candidate to Job"
                visible={jobsallpopup}
                className="interview-popup"
                onHide={() => {
                    SetJobsallPopup(false)
                    setFormErrors({})
                    resetForm();
                }}
                style={{ width: "75vw", height: "82%" }}
                maximizable
                modal
                footer={footerContent}
            >
                <div className="popup-header-bg">
                    <Row className="">
                        <Col xl={6} className="ps-3 d-flex align-items-center">
                            <div className="popup-header d-flex">
                                <Dropdown
                                    value={selectedEmailOption1}
                                    onChange={handleTemplateChange}

                                    options={emailOptions1}
                                    optionLabel="label"
                                    placeholder="Template"
                                    valueTemplate={selectedEmailTemplate1}
                                    itemTemplate={emailOptionTemplate1}
                                    className="w-full md:w-10rem action-items me-1"
                                    dropdownIcon={opts => {
                                        return opts.iconProps["data-pr-overlay-visible"] ? (
                                            <ChevronRightIcon {...opts.iconProps} />
                                        ) : (
                                            <ChevronDownIcon {...opts.iconProps} />
                                        )
                                    }}
                                />

                                <Dropdown
  value={selectedSmsOption}
  onChange={handleSignatureChange}
  options={smsOptions1}
  optionLabel="label"
  placeholder="Signature"
  valueTemplate={selectedSmsTemplate}
  itemTemplate={smsOptionTemplate}
  className="w-full md:w-10rem action-items me-1"
  dropdownIcon={opts => {
    return opts.iconProps["data-pr-overlay-visible"] ? (
      <ChevronRightIcon {...opts.iconProps} />
    ) : (
      <ChevronDownIcon {...opts.iconProps} />
    )
  }}
/>


                                <div
  className="me-2"
  style={{ display: "flex", alignItems: "center" }}
>
  <Tooltip target=".attachment-button" content="Upload Files" />
  <FileUpload
    ref={fileUploadRef}
    name="emailAttachments[]"
    url={"/api/upload"}
    mode="basic"
    multiple
    accept="image/*,application/pdf"
    maxFileSize={5000000}
    auto
    chooseLabel={<span>Attach Files</span>}
    customUpload
    uploadHandler={onUploadHandler1}
    onChoose={(e) => {
      if (fileUploadRef.current) {
        fileUploadRef.current.clear(); // Clear the input after selection to allow new picks
      }
    }}
  />
</div>

                                {/* <Dropdown
                                    value={selectedOption}
                                    onChange={e => setSelectedOption(e.value)}
                                    // options={options1}
                                    optionLabel="label"
                                    placeholder="Preview"
                                    valueTemplate={selectedOptionTemplate}
                                    itemTemplate={optionTemplate}
                                    className="preview-icon w-full md:w-7rem action-items"
                                    dropdownIcon={opts => {
                                        return opts.iconProps["data-pr-overlay-visible"] ? (
                                            <EyeIcon {...opts.iconProps} /> // Replace with the EyeIcon
                                        ) : (
                                            <ChevronDownIcon {...opts.iconProps} />
                                        )
                                    }}
                                /> */}
                            </div>
                        </Col>

                        <Col xl={6}>
                            <div class="d-flex justify-content-end align-items-center mt-1">
                                <button
                                    type="button"
                                    class="waves-effect waves-light outlinebtn btn btn-primary me-2"
                                    onClick={handleSendJob}
                                    disabled={isSending}
                                >
                                    {" "}
                                    <i class="fa-regular fa-paper-plane me-2"></i>{isSending ? "Sending..." : "Send"} 
                                </button>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="bg-form form-insidepop">
                    <Row className="mb-2">
                        <Col xl={12}>
                            <Row className="mb-2">
                                <Col xl={1} className="pe-0">
    <div className="label-input">
        <Dropdown
            value={frominputemail}
            onChange={(e) => {
                const selected = e.value.code; // Use email string
                setFrominputemail(e.value);
                setFromemailjobs(selected); // Set single email, replacing previous
            }}
            options={fromEmail}
            optionLabel="name"
            placeholder="From"
            className="from-width w-full"
        />
    </div>
</Col>
<Col xl={11}>
    <Chips
        value={fromemailjobs ? [fromemailjobs] : []} // Display as single-item array for Chips
        onChange={e => setFromemailjobs(e.value[0] || '')} // Update to single string
        itemTemplate={Fromemailcontjobs}
        className="size-mail w-full"
    />
    <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.from}</p>
</Col>

                            </Row>

                            <Row className="mb-2">
                                <Col xl={1} className="pe-0">
                                    <div className="label-input">
                                        <Dropdown
                                            placeholder="To"
                                            className="from-width w-full"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLinkContactsVisible(true);
                                            }}
                                            showClear={false}
                                            showOnFocus={false}
                                        />
                                    </div>
                                </Col>
                                <Col xl={11}>

                                    <Chips
                                        value={jobDescriptions}
                                        onChange={(e) => setJobDescriptions(e.value)}
                                        className="size-mail w-full"
                                    />
                                    <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.to}</p>
                                </Col>
                            </Row>

                            <Row className="mb-2">
                                <Col xl={1} className="pe-0">
                                    <div className="label-input">
                                        <Dropdown
                                            placeholder="Cc"
                                            className="from-width w-full"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLinkContactsVisible1(true);
                                            }}
                                            showClear={false}
                                            showOnFocus={false}
                                        />
                                    </div>
                                </Col>
                                <Col xl={11}>

                                    <Chips
                                        value={contactDescriptions}
                                        onChange={(e) => setContactDescriptions(e.value)}
                                        className="size-mail w-full"
                                    />
                                </Col>
                            </Row>

                            <Row className="size-mail mb-1">
                                <Col xl={1}>
                                    <label htmlFor="interview">Subject:</label>
                                </Col>
                                <Col xl={11}>
                                    <InputText
                                        id="interview"
                                        aria-describedby="username-help"
                                        placeholder=""
                                        className="w-full"
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                    />
                                    <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.subject}</p>
                                </Col>
                            </Row>

                            {/* Attached Files Section */}
                            {attachmentfile.length > 0 && ( // Always show if there are files
                                <Row className="size-mail mt-2 align-items-baseline">
                                    <Col xl={1}>
                                        <label>Attached:</label>
                                    </Col>

                                    <Col xl={11}>
                                        {/* Scrollable File List */}
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* Uploaded Files List */}
                                            <div
                                                ref={fileListRef}
                                                style={{
                                                    display: "flex",
                                                    overflowX: "auto",
                                                    whiteSpace: "nowrap",
                                                    maxWidth: "100%",
                                                    padding: "10px 0px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {attachmentfile.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            marginRight: "15px",
                                                            padding: "5px 10px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "4px",
                                                            background: "#f9f9f9",
                                                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                                        }}
                                                    >
                                                        <div>
                                                            <i
                                                                className="pi pi-file"
                                                                style={{ marginRight: "5px" }}
                                                            ></i>
                                                            <span>{file.file_name}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12}>
                            <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.body}</p>
                            <Editor
                                value={emailtextEditor}
                                onTextChange={e => setEmailtextEditor(e.htmlValue)}
                                className="jobsall-editor"
                            />

                        </Col>
                    </Row>
                </div>
            </Dialog>

            {/* select job popup */}

            <Dialog
                header="Select Job"
                visible={jobDetailsVisible}
                onHide={() => {
        if (selectedJobs.length === 0) {
            setJobDialogWarning("Select at least one job");
            return; // Prevent closing
        }
        setJobDetailsVisible(false);
        setJobDialogWarning(""); // Clear warning
    }}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                <Row>
                    <Col lg={12}>
                        <div
                            className="p-inputgroup mb-3"
                            style={{ position: "relative" }}
                        >
                            <InputText
                                placeholder="Search Jobs"
                                value={searchText}
                                onInput={e => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }} // Space for the icon
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>

                <DataTable
                    value={filteredJobs}
                    selection={selectedJobs}
                    onSelectionChange={e => {
        setSelectedJobs(e.value);
        if (e.value.length === 0) {
            setJobDialogWarning("Select at least one job");
        } else {
            setJobDialogWarning(""); // Clear warning when a job is selected
        }
    }}
                    dataKey="id"
                    size="small" // Set size to small
                    lazy
                    paginator first={lazyParams.page * lazyParams.rows}
                    rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPageChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalRecords]} // Dynamic row options including "All"
                >
                    <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="job_number" header="Job ID" />
                    <Column field="title" header="Job Title" />
                    <Column field="manager" header="Contact" />
                </DataTable>

                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={() => {
                if (selectedJobs.length === 0) {
                    setJobDialogWarning("Select at least one job");
                    return; // Prevent closing
                }
                handleSave();
                setJobDialogWarning(""); // Clear warning
            }}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefresh}
                    >
                        Refresh
                    </button>
                </div>
                {jobDialogWarning && (
        <div style={{ color: "red", marginTop: "10px" }}>
            {jobDialogWarning}
        </div>
    )}
            </Dialog>

            {/* select contactsform popup for To */}
            <Dialog
                header="Select Contact"
                visible={linkContactsVisible}
                onHide={() => setLinkContactsVisible(false)}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                {/* Search Bar */}
                <Row>
                    <Col lg={12}>
                        <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
                            <InputText
                                placeholder="Search Contact"
                                value={searchText}
                                onInput={(e) => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }}
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>

                {/* DataTable */}
                <DataTable
                    key={selectedContacts.length} // Force re-render when selectedContacts changes
                    value={contacts}
                    paginator

                    selection={selectedContacts}
                    onSelectionChange={(e) => setSelectedContacts(e.value)}
                    dataKey="id"
                    size="small"

                    lazy
                    first={lazyParamsContacts.page * lazyParamsContacts.rows}
                    rows={lazyParamsContacts.rows} totalRecords={totalContacts} onPage={onPageContactsChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalContacts]} // Dynamic row options including "All"
                >
                    <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="first_name" header="Contact Name" />
                    <Column field="role_name" header="Designation" />
                    <Column field="email" header="Email" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={handleSaveContact}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefresh1}
                    >
                        Refresh
                    </button>
                </div>
            </Dialog>

            {/* select contactsform popup for cc */}
            <Dialog
                header="Select Contact"
                visible={linkContactsVisible1}
                onHide={() => setLinkContactsVisible1(false)}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                {/* Search Bar */}
                <Row>
                    <Col lg={12}>
                        <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
                            <InputText
                                placeholder="Search Contact"
                                value={searchText}
                                onInput={(e) => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }}
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>

                {/* DataTable */}
                <DataTable
                    key={selectedContacts1.length} // Force re-render when selectedContacts1 changes
                    value={contacts}
                    selection={selectedContacts1}
                    onSelectionChange={(e) => setSelectedContacts1(e.value)}
                    dataKey="id"
                    size="small"
                    lazy
                    first={lazyParamsContacts.page * lazyParamsContacts.rows}
                    rows={lazyParamsContacts.rows} totalRecords={totalContacts} onPage={onPageContactsChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalContacts]} // Dynamic row options including "All"
                >
                    <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="first_name" header="Contact Name" />
                    <Column field="role_name" header="Designation" />
                    <Column field="email" header="Email" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={handleSaveContact1}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefresh2}
                    >
                        Refresh
                    </button>
                </div>
            </Dialog>


            {/* submit candidate to contact */}
            <Dialog
                header="Submit Candidate to Contact"
                visible={submitcantocon}
                className="interview-popup"
                onHide={() => {
                    SetSubmitcantocon(false)
                    setFormErrors({}); 
                    resetFormContact()
                }}
                style={{ width: "75vw", height: "82%" }}
                maximizable
                modal
                footer={footerContent}
            >
                <div className="popup-header-bg">
                    <Row className="">
                        <Col xl={6} className="ps-4 d-flex align-items-center">
                            <div className="popup-header d-flex">
                                <Dropdown
                                    value={selectedEmailOption1}
                                    // onChange={e => setSelectedEmailOption1(e.value)}
                                    onChange={handleTemplateChange}
                                    options={emailOptions1}
                                    optionLabel="label"
                                    placeholder="Template"
                                    valueTemplate={selectedEmailTemplate1}
                                    itemTemplate={emailOptionTemplate1}
                                    className="w-full md:w-10rem action-items me-1"
                                    dropdownIcon={opts => {
                                        return opts.iconProps["data-pr-overlay-visible"] ? (
                                            <ChevronRightIcon {...opts.iconProps} />
                                        ) : (
                                            <ChevronDownIcon {...opts.iconProps} />
                                        )
                                    }}
                                />

                                <Dropdown
  value={selectedSmsOption}
  onChange={handleSignatureChange}
  options={smsOptions1}
  optionLabel="label"
  placeholder="Signature"
  valueTemplate={selectedSmsTemplate}
  itemTemplate={smsOptionTemplate}
  className="w-full md:w-10rem action-items me-1"
  dropdownIcon={opts => {
    return opts.iconProps["data-pr-overlay-visible"] ? (
      <ChevronRightIcon {...opts.iconProps} />
    ) : (
      <ChevronDownIcon {...opts.iconProps} />
    )
  }}
/>


                                <div
    className="me-2"
    style={{ display: "flex", alignItems: "center" }}
>
    <Tooltip target=".attachment-button" content="Upload Files" />
    <FileUpload
        ref={fileUploadRef}
        name="emailAttachments[]"
        url={"/api/upload"}
        mode="basic"
        multiple
        accept="image/*,application/pdf"
        maxFileSize={5000000}
        chooseLabel={<span>Attach Files</span>}
        customUpload
        uploadHandler={onUploadHandler1}
        onSelect={(e) => {
            // Trigger the upload handler manually
            onUploadHandler1(e);
            // Clear the file input after selection to ensure the file picker opens next time
            if (fileUploadRef.current) {
                fileUploadRef.current.clear();
            }
        }}
        className="attachment-button"
    />
</div>

                                {/* <Dropdown
                                    value={selectedOption}
                                    onChange={e => setSelectedOption(e.value)}
                                    // options={options1}
                                    optionLabel="label"
                                    placeholder="Preview"
                                    valueTemplate={selectedOptionTemplate}
                                    itemTemplate={optionTemplate}
                                    className="preview-icon w-full md:w-7rem action-items"
                                    dropdownIcon={opts => {
                                        return opts.iconProps["data-pr-overlay-visible"] ? (
                                            <EyeIcon {...opts.iconProps} /> // Replace with the EyeIcon
                                        ) : (
                                            <ChevronDownIcon {...opts.iconProps} />
                                        )
                                    }}
                                /> */}
                            </div>
                        </Col>

                        <Col xl={6}>
                            <div class="d-flex justify-content-end align-items-center mt-1">
                                <button
                                    type="button"
                                    class="waves-effect waves-light outlinebtn btn btn-primary me-2"
                                    onClick={handleSendContact}
                                    disabled={isSending}
                                >
                                    {" "}
                                    <i class="fa-regular fa-paper-plane me-2"></i>{isSending ? "Sending..." : "Send"}
                                </button>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="bg-form form-insidepop">
                    <Row className="mb-2">
                        <Col xl={12}>
                            <Row className="mb-2">
    <Col xl={1} className="pe-0">
        <div className="label-input">
            <Dropdown
                value={frominputemail}
                onChange={(e) => {
                    const selected = e.value.code;
                    setFrominputemail(e.value);
                    setFromemailjobs(selected); // Set as single string
                }}
                options={fromEmail}
                optionLabel="name"
                placeholder="From"
                className="from-width w-full"
            />
        </div>
    </Col>
    <Col xl={11}>
        <Chips
            value={fromemailjobs ? [fromemailjobs] : []} // Display as single-item array for Chips
            onChange={(e) => setFromemailjobs(e.value[0] || '')} // Extract first item or empty string
            itemTemplate={Fromemailcontjobs}
            className="size-mail w-full"
        />
        <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.from}</p>
    </Col>
</Row>

                            <Row className="mb-2">
                                <Col xl={1} className="pe-0">
                                    <div className="label-input">
                                        <Dropdown
                                            placeholder="To"
                                            className="from-width w-full"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLinkContactstoVisible(true);
                                            }}
                                            showClear={false}
                                            showOnFocus={false}
                                        />
                                    </div>
                                </Col>
                                <Col xl={11}>

                                    <Chips
                                        value={autoToemail}
                                        onChange={(e) => setAutoToemail(e.value)}
                                        className="size-mail w-full"
                                        separator=","
                                        itemTemplate={(item) => <span>{item.label}</span>}
                                    />
<p style={{ color: 'red', fontSize: '13px' }}>{formErrors.to}</p>
                                </Col>
                            </Row>

                            <Row className="mb-2">
                                <Col xl={1} className="pe-0">
                                    <div className="label-input">
                                        <Dropdown
                                            placeholder="Cc"
                                            className="from-width w-full"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setLinkContactsVisiblecc(true);
                                            }}
                                            showClear={false}
                                            showOnFocus={false}
                                        />
                                    </div>
                                </Col>
                                <Col xl={11}>
                                    <Chips
                                        value={contactDescriptionscc}
                                        onChange={(e) => setContactDescriptionscc(e.value)}
                                        className="size-mail w-full"
                                    />
                                </Col>
                            </Row>

                            <Row className="size-mail mb-1">
                                <Col xl={1}>
                                    <label htmlFor="interview">Subject:</label>
                                </Col>
                                <Col xl={11}>
                                    <InputText
                                        id="interview"
                                        aria-describedby="username-help"
                                        placeholder=""
                                        className="w-full"
                                         value={subject}
                                        onChange={(e) => setSubject(e.target.value)}

                                    />
                                    <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.subject}</p>
                                </Col>
                            </Row>

                           
                             {/* Attached Files Section */}
                            {attachmentfile.length > 0 && ( // Always show if there are files
                                <Row className="size-mail mt-2 align-items-baseline">
                                    <Col xl={1}>
                                        <label>Attached:</label>
                                    </Col>

                                    <Col xl={11}>
                                        {/* Scrollable File List */}
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* Uploaded Files List */}
                                            <div
                                                ref={fileListRef}
                                                style={{
                                                    display: "flex",
                                                    overflowX: "auto",
                                                    whiteSpace: "nowrap",
                                                    maxWidth: "100%",
                                                    padding: "10px 0px",
                                                    borderRadius: "4px",
                                                }}
                                            >
                                                {attachmentfile.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            marginRight: "15px",
                                                            padding: "5px 10px",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "4px",
                                                            background: "#f9f9f9",
                                                            boxShadow: "0px 1px 2px rgba(0,0,0,0.1)",
                                                        }}
                                                    >
                                                        <div>
                                                            <i
                                                                className="pi pi-file"
                                                                style={{ marginRight: "5px" }}
                                                            ></i>
                                                            <span>{file.file_name}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12}>
                            <p style={{ color: 'red', fontSize: '13px' }}>{formErrors.body}</p>
                            <Editor
                                value={emailtextEditor} // Display job descriptions with default text
                                onTextChange={e => setEmailtextEditor(e.htmlValue)}
                                className="jobsall-editor"
                            />

                        </Col>
                    </Row>
                </div>
            </Dialog>


            {/* auto popup of can to con */}
            <Dialog
                header="Select Contact"
                visible={ccDetailsVisible}
                onHide={() => setccDetailsVisible(false)}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                {/* Search Bar */}
                <Row>
                    <Col lg={12}>
                        <div
                            className="p-inputgroup mb-3"
                            style={{ position: "relative" }}
                        >
                            <InputText
                                placeholder="Search Contacts"
                                value={searchText}
                                onInput={e => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }} // Space for the icon
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>


                {/* DataTable */}
                <DataTable
                    value={contacts}
                    paginator
                    selection={selectedAutocc}
                    onSelectionChange={e => setSelectedAutocc(e.value)}
                    dataKey="id"
                    size="small" // Set size to small

                    lazy
                    first={lazyParamsContacts.page * lazyParamsContacts.rows}
                    rows={lazyParamsContacts.rows} totalRecords={totalContacts} onPage={onPageContactsChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalContacts]} // Dynamic row options including "All"
                >
                    <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="first_name" header="Contact Name" />
                    <Column field="role_name" header="Designation" />
                    <Column field="email" header="Email" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={handleSaveautocc}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefreshautocc}
                    >
                        Refresh
                    </button>
                </div>
            </Dialog>

            {/* submit can to contact for To */}
            <Dialog
                header="Select Contact"
                visible={linkContactstoVisible}
                onHide={() => setLinkContactstoVisible(false)}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                {/* Search Bar */}
                <Row>
                    <Col lg={12}>
                        <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
                            <InputText
                                placeholder="Search Contacts"
                                value={searchText}
                                onInput={(e) => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }}
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>

                {/* DataTable */}
                <DataTable
                    key={selectedContactsto.length} // Force re-render when selectedContacts changes
                    value={contacts}
                    paginator
                    selection={selectedContactsto}
                    onSelectionChange={(e) => setSelectedContactsto(e.value)}
                    dataKey="id"
                    size="small"
lazy
                    first={lazyParamsContacts.page * lazyParamsContacts.rows}
                    rows={lazyParamsContacts.rows} totalRecords={totalContacts} onPage={onPageContactsChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalContacts]} // Dynamic row options including "All"
                    
                >
                   <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="first_name" header="Contact Name" />
                    <Column field="role_name" header="Designation" />
                    <Column field="email" header="Email" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={handleSaveContactto}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefreshto}
                    >
                        Refresh
                    </button>
                </div>
            </Dialog>

            {/* select candidates to contacts popup for cc */}
            <Dialog
                header="Select Contact"
                visible={linkContactsVisiblecc}
                onHide={() => setLinkContactsVisiblecc(false)}
                style={{ width: "40vw" }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}
                className="cand-details"
            >
                {/* Search Bar */}
                <Row>
                    <Col lg={12}>
                        <div className="p-inputgroup mb-3" style={{ position: "relative" }}>
                            <InputText
                                placeholder="Search Contacts"
                                value={searchText}
                                onInput={(e) => setSearchText(e.target.value)}
                                style={{ paddingRight: "2rem" }}
                            />
                            <i
                                className="pi pi-search"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "49%",
                                    transform: "translateY(-50%)",
                                }}
                            ></i>
                        </div>
                    </Col>
                </Row>

                {/* DataTable */}
                <DataTable
                    key={selectedContactscc.length} // Force re-render when selectedContacts1 changes
                    value={contacts}
                    paginator
                    selection={selectedContactscc}
                    onSelectionChange={(e) => setSelectedContactscc(e.value)}
                    dataKey="id"
                    size="small"

                    lazy
                    first={lazyParamsContacts.page * lazyParamsContacts.rows}
                    rows={lazyParamsContacts.rows} totalRecords={totalContacts} onPage={onPageContactsChange} loading={loading}
                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    rowsPerPageOptions={[10, 20, 50, totalContacts]} // Dynamic row options including "All"
                >
                     <Column selectionMode="multiple" style={{ width: "3em" }} />
                    <Column field="first_name" header="Contact Name" />
                    <Column field="role_name" header="Designation" />
                    <Column field="email" header="Email" />
                </DataTable>

                {/* Actions */}
                <div className="d-flex mt-3">
                    <button
                        type="button"
                        className="btn btn-primary me-2 btn-main"
                        onClick={handleSaveContactcc}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary btn-main"
                        onClick={handleRefreshcc}
                    >
                        Refresh
                    </button>
                </div>
            </Dialog>
            <Dialog
    header="No Subject"
    visible={confirmNoSubject}
    style={{ width: "400px" }}
    modal
    onHide={handleCancelSend}
    footer={
        <div>
            <button className="btn btn-primary me-2" onClick={handleConfirmSend}>Yes, Send</button>
            <button className="btn btn-secondary" onClick={handleCancelSend}>Cancel</button>
        </div>
    }
>
    <p>Do you want to send this email without a subject?</p>
</Dialog>

        </React.Fragment>
    )
})
export default SubmitCandidatetoJob